var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticClass:"icon",attrs:{"src":require("./assets/logo.png")}}),_c('h2',[_vm._v(" 欢迎来到创之道网络科技公司 ")]),_c('HelloWorld',{attrs:{"msg":"Welcome"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }